import { state } from '../lib/state.js';
import { loadLineCalculatorSettings, saveLineCalculatorSettings } from '../services/repository.js';
import { startCountryBrowserlessJob } from '../services/browserless-country-dispatch.js';
import { els } from '../app/dom.js';
import { requireAuthenticatedSession } from '../app/auth.js';
import { setStatus, sectionDistanceKm, formatDuration } from '../lib/app-helpers.js';
import { prepareSectionMetrics } from './common.js';

const ASFINAG_SETTINGS_KEY = 'd24-asfinag-at-settings';
let pendingAsfinagSection = null;

export function normalizeAsfinagVehicleSettings(settings={}) {
  const source={...(settings||{})};
  let category=String(source.vehicleCategory||'').trim().toLowerCase();
  let axles=String(source.axles||'').trim();

  if (!category && ['2','3','4'].includes(axles)) category=`bus-${axles}`;
  const match=category.match(/^bus-([234])$/);
  if (match) axles=match[1];

  return {
    ...source,
    vehicleType:'bus',
    vehicleCategory:match ? `bus-${axles}` : '',
    axles:match ? axles : '',
  };
}

export async function openAsfinagDialog(section){
  pendingAsfinagSection=section;
  const localDefaults=loadAsfinagSettings();
  let savedForLine=null;
  try{savedForLine=await loadLineCalculatorSettings(state.organizationId,state.currentRoute.lineNumber,'asfinag-at');}catch(error){console.warn('[D24 ASFINAG] Parametry linii:',error);}
  const defaults=normalizeAsfinagVehicleSettings({...localDefaults,...(savedForLine||{})});
  els.asfinagAxles.value=defaults.axles||'';
  els.asfinagEmissionClass.value=defaults.emissionClass||'';
  els.asfinagCo2Class.value=defaults.co2Class||'';
  els.asfinagDialogRoute.textContent=`${section.countryName}: ${section.points.map(point=>point.name).join(' → ')}`;
  els.asfinagDialog.classList.remove('hidden');
  els.asfinagDialog.setAttribute('aria-hidden','false');
  document.body.style.overflow='hidden';
  setTimeout(()=>els.asfinagAxles.focus(),0);
}

export function closeAsfinagDialog(){
  pendingAsfinagSection=null;
  els.asfinagDialog?.classList.add('hidden');
  els.asfinagDialog?.setAttribute('aria-hidden','true');
  document.body.style.overflow='';
}

export async function submitAsfinagDialog(event){
  event.preventDefault();
  if(!pendingAsfinagSection)return;
  if(!els.asfinagForm.reportValidity())return;
  const section=pendingAsfinagSection;
  const selectedAxles=String(els.asfinagAxles.value||'').trim();
  if(!['2','3','4'].includes(selectedAxles)){
    return setStatus(els.extensionStatus,'ASFINAG: wybierz kategorię autobusu: 2, 3 albo 4 osie.','error');
  }
  const settings=normalizeAsfinagVehicleSettings({
    vehicleCategory:`bus-${selectedAxles}`,
    axles:selectedAxles,
    emissionClass:els.asfinagEmissionClass.value,
    co2Class:els.asfinagCo2Class.value,
  });
  localStorage.setItem(ASFINAG_SETTINGS_KEY,JSON.stringify(settings));
  try{await saveLineCalculatorSettings(state.organizationId,state.currentRoute.lineNumber,'asfinag-at',settings);}catch(error){return setStatus(els.extensionStatus,`Nie udało się zapisać parametrów ASFINAG: ${error.message}`,'error');}
  closeAsfinagDialog();
  await runAsfinagAt(section,settings);
}

export async function runAsfinagAt(section,settings){
  if(!await requireAuthenticatedSession('uruchomić kalkulator ASFINAG Austria'))return;

  settings=normalizeAsfinagVehicleSettings(settings);
  if(!['bus-2','bus-3','bus-4'].includes(settings.vehicleCategory)){
    return setStatus(els.extensionStatus,'ASFINAG: brak poprawnej kategorii autobusu (2/3/4 osie).','error');
  }

  const preparedSection=await prepareSectionMetrics(section,'austriackiego');
  if(!preparedSection)return;

  const distanceKm=sectionDistanceKm(preparedSection);
  const durationText=Number.isFinite(Number(preparedSection.durationSeconds))?formatDuration(Number(preparedSection.durationSeconds)):'';
  const jobId=crypto.randomUUID();
  const payload={
    jobId,
    calculatorKey:'asfinag-at',
    routeId:state.currentRoute.id,
    routeVersionId:state.currentRoute.versionId,
    routeTitle:state.currentRoute.title,
    sourceFile:state.currentRoute.sourceFileName,
    countryCode:'AT',
    countryName:'Austria',
    sectionId:preparedSection.id,
    sectionOrder:preparedSection.order,
    distanceKm,
    durationText,
    points:preparedSection.points.map(p=>({
      name:p.name,
      address:p.address||'',
      countryCode:p.countryCode||'',
      countryName:p.countryName||'',
      country:p.countryName||'',
      type:p.isBorder?'Granica':'Przystanek',
      pointType:p.isBorder?'border':'stop',
      lat:p.lat,
      lon:p.lon,
      isBorder:Boolean(p.isBorder),
      borderName:p.borderName||'',
      requestedBorderPair:p.requestedBorderPair||'',
      resolvedDisplayName:p.resolvedDisplayName||'',
      query:`${p.lat}, ${p.lon}`,
    })),
    // Parametry pochodzą bezpośrednio z istniejącego modala ASFINAG.
    settings:{...settings},
  };

  setStatus(els.extensionStatus,`Uruchamiam ASFINAG: Autobus ${settings.axles} osie · ${preparedSection.points.length} punktów…`,'working');
  try{await startCountryBrowserlessJob(payload);}catch(error){console.error('[D24 BROWSERLESS ASFINAG]',error);}
}



export function loadAsfinagSettings(){
  try{return JSON.parse(localStorage.getItem(ASFINAG_SETTINGS_KEY)||'{}');}
  catch{return {};}
}

